import http from "../http";

export async function getApplications(data) {
  const response = await http.get("/analytics/application-onboarding", data);
  return response.data;
}

export async function getApplicationReports(data) {
  const response = await http.get("/analytics-export/application-onboarding", data);
  return response.data;
}

export async function getSellers(data) {
  const response = await http.get("/analytics/monitoring/seller", data);
  return response.data;
}

export async function getSellersReports(data) {
  const response = await http.get("/analytics-export/monitoring/seller", data);
  return response.data;
}

export async function getCreditScore(data) {
  const response = await http.get("/analytics/monitoring/biz-credit-score", data);
  return response.data;
}

export async function getCreditScoreReports(data) {
  const response = await http.get("/analytics-export/monitoring/biz-credit-score", data);
  return response.data;
}

export async function getOverview(data) {
  const response = await http.get("/analytics/customer", data);
  return response.data;
}

export async function getOverviewReports(data) {
  const response = await http.get("/analytics-export/customer", data);
  return response.data;
}
